"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.patientConditionTypes = void 0;
var patientConditionTypes;
(function (patientConditionTypes) {
    patientConditionTypes["HYPERTENSION"] = "hypertension";
    patientConditionTypes["DIABETES"] = "diabetes";
    patientConditionTypes["KIDNEY_STONES"] = "kidneyStones";
    patientConditionTypes["BMI_OVER_30"] = "bmiOver30";
    patientConditionTypes["CKD_FAMILY_HISTORY"] = "ckdFamilyHistory";
    patientConditionTypes["CKD"] = "ckd";
})(patientConditionTypes || (exports.patientConditionTypes = patientConditionTypes = {}));
